import React from 'react';
import { StyleSheet, TextStyle, View, ViewStyle } from 'react-native';

import { AssetImage } from '../../../App/assets/AssetImage';
import { Fonts } from '../../../Common/services/utils/AppConstants';
import { PaywallAssets } from '../../../Paywall/assets';

type Props = {
  backgroundColor: string;
  color: string;
  viewStyle?: ViewStyle;
  textStyle?: TextStyle;
};

export const GradeLockedIndicator = (props: Props): React.ReactElement => {
  const { backgroundColor, color, viewStyle, textStyle } = props;

  return (
    <View style={[styles.circle, { backgroundColor }, viewStyle]}>
      <AssetImage
        width={20}
        asset={PaywallAssets.lockIcon}
        containerStyle={[styles.text, { color }, textStyle]}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  circle: {
    width: 50,
    height: 50,
    borderRadius: 25,
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    ...Fonts.largeBold,
  },
});
